const WORKSPACE_PATH_SEGMENT = "workspace";
const WORKSPACE_CHAT_PATH_SEGMENT = "chat";

export const buildUseCasePromptLink = (
  origin: string,
  promptId: string,
  useCaseId: string,
  workspaceId?: string,
): string => {
  const pathname = workspaceId
    ? `/${WORKSPACE_PATH_SEGMENT}/${encodeURIComponent(workspaceId)}/${WORKSPACE_CHAT_PATH_SEGMENT}`
    : "";
  return `${origin}${pathname}?promptId=${encodeURIComponent(promptId)}&useCaseId=${encodeURIComponent(useCaseId)}`;
};
